import styled, { css } from 'styled-components';
import Icon from '@anwb/icon';
import { pxToRem } from '@anwb/style-utilities';
import Typography from '@anwb/typography';
/**
 * Video Aspect Ratio Styles
 */
export const videoAspectRatioStyles = () => css `
	aspect-ratio: 16 / 9;
	width: 100%;
`;
/**
 * Video Aspect Ratio Polyfill Styles
 */
export const videoAspectRatioOverrideStyles = () => css `
	height: 100%;
	width: 100%;
	left: 0;
	top: 0;
	position: absolute;
`;
/**
 * Video Container
 */
export const videoContainerStyles = ({ theme }) => css `
	width: 100%;
	height: 100%;

	background: ${theme.colors.light.bgMediaPlaceholder};

	// Overrides for browsers incompatible with aspect-ratio, mainly Safari iOS 14 and below
	@supports not (aspect-ratio: 1) {
		padding-bottom: 56.25%; // VooDoo code :)
		position: relative;

		${VideoIframe} {
			${videoAspectRatioOverrideStyles}
		}

		${VideoConsent} {
			${videoAspectRatioOverrideStyles}
		}
	}
`;
export const VideoContainer = styled.div `
	${videoContainerStyles}
`;
/**
 * Video Iframe
 */
export const videoIframeStyles = () => css `
	border: 0;
	box-shadow: 0;
`;
export const VideoIframe = styled.iframe `
	${videoIframeStyles}
	${videoAspectRatioStyles}
`;
/**
 * Video Consent
 */
export const videoConsentStyles = ({ theme }) => css `
	align-items: center;
	display: flex;
	flex-direction: column;
	justify-content: center;

	gap: ${pxToRem(theme.spacing['200'])};
	padding: ${pxToRem(theme.spacing['200'])};

	@media (min-width: ${pxToRem(theme.viewportBreakpoint.md)}) {
		gap: ${pxToRem(theme.spacing['300'])};
		padding: ${pxToRem(theme.spacing['300'])};
	}
`;
export const VideoConsent = styled.div `
	${videoConsentStyles}
	${videoAspectRatioStyles}
`;
/**
 * Video Consent Body
 */
export const videoConsentTextStyles = ({ theme }) => css `
	color: ${theme.colors.informative.textSupport};
	height: auto;
	max-width: ${pxToRem(theme.spacing['1100'])};
	text-align: center;
`;
export const VideoConsentText = styled(Typography).attrs(() => ({
    tagName: 'div',
    variant: 'support-text',
})) `
	${videoConsentTextStyles}
`;
/**
 * Video Consent Body
 */
export const videoConsentLinkStyles = ({ theme }) => css `
	color: ${theme.colors.highlight.textLink};

	&:hover,
	&:focus {
		color: ${theme.colors.highlight.textHover};
	}

	&:active {
		color: ${theme.colors.action.textActive};
	}
`;
export const VideoConsentLink = styled.a `
	${videoConsentLinkStyles}
`;
/**
 * Video Consent Icon
 */
export const videoConsentIconStyles = ({ theme }) => css `
	color: ${theme.colors.base.iconUi};
	display: none;
	height: auto;
	line-height: 22px; // TODO: remove when icon line-height is fixed

	@media (min-width: ${pxToRem(theme.viewportBreakpoint.sm)}) {
		display: block;
	}
`;
export const VideoConsentIcon = styled(Icon).attrs(() => ({
    size: 'xl',
    variant: 'eye-off',
})) `
	${videoConsentIconStyles}
`;
//# sourceMappingURL=video.styled.js.map